import { render } from "./QrPayment.vue?vue&type=template&id=7042536a&scoped=true"
import script from "./QrPayment.vue?vue&type=script&lang=js"
export * from "./QrPayment.vue?vue&type=script&lang=js"

import "./QrPayment.vue?vue&type=style&index=0&id=7042536a&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7042536a"]])

export default __exports__